"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prescriptionRepositoryMethods = void 0;
const repository_types_1 = require("./repository.types");
exports.prescriptionRepositoryMethods = (0, repository_types_1.generateRepositoryMethods)({
    getPrescriptionsWithoutRenewalsByYear: {
        callMethod: 'GET',
        endpoint: '/prescriptions/without-renewals-by-year',
    },
    getAllPrescriptionRequests: {
        callMethod: 'GET',
        endpoint: '/prescription-requests/all',
    },
    getAllPrescriptions: {
        callMethod: 'GET',
        endpoint: '/prescriptions/all',
    },
    getExpiredPrescriptions: {
        callMethod: 'GET',
        endpoint: '/prescriptions/expired',
    },
    createPrescriptionRequest: {
        callMethod: 'POST',
        endpoint: '/prescription-requests/create',
    },
    generatePrescriptionRequestPDF: {
        callMethod: 'POST',
        endpoint: '/prescription-requests/pdf',
    },
});
//# sourceMappingURL=prescription.methods.js.map